import { type CSSProperties, memo, useMemo } from 'react';

import { Skeleton } from 'antd';
import cn from 'classnames';

import cls from './full-size-skeleton.module.css';

interface FullSizeSkeletonProps {
    className?: string;
    isActive?: boolean;
    width?: CSSProperties['width'];
    height?: CSSProperties['height'];
}

export const FullSizeSkeleton = memo((props: FullSizeSkeletonProps) => {
    const { className, isActive = false, width, height } = props;

    const style = useMemo<CSSProperties>(() => {
        const baseStyle = width ? { maxWidth: width, minWidth: width } : {};

        return height
            ? { ...baseStyle, maxHeight: height, minHeight: height }
            : baseStyle;
    }, [width, height]);

    return (
        <Skeleton.Button
            active={isActive}
            className={cn(cls.root, className)}
            style={style}
        />
    );
});

FullSizeSkeleton.displayName = 'FullSizeSkeleton';
